import type { TenantConfig } from '@/types/TenantConfig'

export const tenement: TenantConfig = {
  logo: 'assets/tenement/static/logo.png',
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/tenement/static/complete.jpg',
      },
      completedContentOffset: {
        desktop: '-155px',
        mobile: '-140px',
      },
    },
  },
}
